export default __webpack_public_path__ + "static/media/dob_calendar.ddce0fc8.svg";